const PLAYER_TRANSITION_DURATION_MS = 175;
const postloadedToolbarTransitionDurationMs = 150;
const toolsTransition = "_uw7t1v54d7b";
const toolbarCls = "_uw7t1q3bumw";
const playerWrapper = "_uw7pnz1k41";

export { PLAYER_TRANSITION_DURATION_MS, playerWrapper, postloadedToolbarTransitionDurationMs, toolbarCls, toolsTransition };
import "./molecule.toolbar.style.linaria.module.css";
//# sourceMappingURL=molecule.toolbar.style.js.map
